import React, { useState, useContext, useEffect } from "react";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import axios from "axios";
import { AuthContext } from "../../../Context/AuthContext";
import Preloader from "../../../shared/PreLoaders";
import { Authorization } from "../../../Context/Authorization";
const VFCBasicReports = () => {
  const [vfcData, setVfcData] = useState([]);
  const [ranges, setRanges] = useState([]);
  const [division, setDivision] = useState([]);
  const [circle, setCircle] = useState([]);
  const [selectedRange, setSelectedRange] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedCircle, setSelectedCircle] = useState("");
  const [selectedVfc, setSelectedVfc] = useState("");
  const [loading, setLoading] = useState(true);
  const [viewData, setViewData] = useState(false);
  const [vfcBasicData, setVfcBasicData] = useState(null);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);

    const fetchCircle = async () => {
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/circles`, config);
        const data = response.data;

        setCircle(data);
      } catch (err) {
        console.error("Error fetching data", err);
      }
    };

    fetchCircle();
    setLoading(false);
  }, [Api]);

  // Fetch Divisions by Circle
  const handleCircleChange = async (e) => {
    const circleId = e.target.value;
    setSelectedCircle(circleId);
    setSelectedDivision("");
    setSelectedRange("");
    setSelectedVfc("");
    setDivision([]);
    setRanges([]);
    setVfcData([]);
    setLoading(true);

    if (circleId) {
      try {
        const config = Authorization();
        const response = await axios.post(
          `${Api}/api/divisions/divisions-by-circle`,
          { circleId },
          config
        );
        setDivision(response.data);
      } catch (err) {
        console.error("Error fetching divisions", err);
      }
    }
    setLoading(false);
  };

  // Fetch Ranges by Division
  const handleDivisionChange = async (e) => {
    const divisionId = e.target.value;
    setSelectedDivision(divisionId);
    setSelectedRange("");
    setSelectedVfc("");
    setRanges([]);
    setVfcData([]);
    setLoading(true);

    if (divisionId) {
      try {
        const config = Authorization();
        const response = await axios.post(
          `${Api}/api/ranges/ranges-by-division`,

          { divisionId },
          config
        );
        setRanges(response.data);
      } catch (err) {
        console.error("Error fetching ranges", err);
      }
    }
    setLoading(false);
  };

  // Fetch VFCs by Range
  const handleRangeChange = async (e) => {
    const rangeId = e.target.value;
    setSelectedRange(rangeId);
    setSelectedVfc("");
    setVfcData([]);
    setLoading(true);

    if (rangeId) {
      try {
        const config = Authorization();
        const response = await axios.post(
          `${Api}/api/vfcs/vfcs-by-range`,

          {
            rangeId,
          },
          config
        );
        setVfcData(response.data.vfcs);
      } catch (err) {
        console.error("Error fetching VFCs", err);
      }
    }
    setLoading(false);
  };

  // Fetch VFC Basic Profile
  const handleSelectVfc = async (e) => {
    const vfcId = e.target.value;
    setSelectedVfc(vfcId);
    setLoading(true);

    if (vfcId) {
      try {
        const config = Authorization();
        const response = await axios.post(
          `${Api}/api/vfcs/getVfcProfileByVfcId`,

          { id: vfcId },
          config
        );
        setVfcBasicData(response.data.vfc);
      } catch (error) {
        console.error("Error fetching VFC profile data", error);
      }
    }

    setLoading(false);
  };

  const handleViewClick = (e) => {
    e.preventDefault();
    if (selectedVfc) {
      setViewData(true);
    } else {
      setViewData(false);
    }
  };

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title">Basic Reports </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/dashboard" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="-item active" aria-current="page">
              Basic Reports
            </li>
          </ol>
        </nav>
      </div>

      <div className="col-md-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <Form>
              <Row>
                <Col xs={3}>
                  <Form.Group controlId="Circle" className="mb-3">
                    <Form.Label>Circle</Form.Label>
                    <div className="input-container">
                      <Form.Control
                        as="select"
                        value={selectedCircle}
                        onChange={handleCircleChange}
                      >
                        <option value="">Select Circle</option>
                        {circle.map((cir) => (
                          <option key={cir._id} value={cir._id}>
                            {cir.circleName}
                          </option>
                        ))}
                      </Form.Control>
                    </div>
                  </Form.Group>
                </Col>

                <Col xs={3}>
                  <Form.Group controlId="Division" className="mb-3">
                    <Form.Label>Division</Form.Label>
                    <div className="input-container">
                      <Form.Control
                        as="select"
                        value={selectedDivision}
                        onChange={handleDivisionChange}
                      >
                        <option value="">Select Division</option>
                        {division.map((div) => (
                          <option key={div._id} value={div._id}>
                            {div.divisionName}
                          </option>
                        ))}
                      </Form.Control>
                    </div>
                  </Form.Group>
                </Col>

                <Col xs={3}>
                  <Form.Group controlId="Range" className="mb-3">
                    <Form.Label>Range</Form.Label>
                    <div className="input-container">
                      <Form.Control
                        as="select"
                        value={selectedRange}
                        onChange={handleRangeChange}
                      >
                        <option value="">Select Range</option>
                        {ranges.map((range) => (
                          <option key={range._id} value={range._id}>
                            {range.rangeName}
                          </option>
                        ))}
                      </Form.Control>
                    </div>
                  </Form.Group>
                </Col>

                <Col xs={3}>
                  <Form.Group controlId="VFC" className="mb-3">
                    <Form.Label>VFC</Form.Label>
                    <div className="input-container">
                      <Form.Control
                        as="select"
                        value={selectedVfc}
                        onChange={handleSelectVfc}
                      >
                        <option value="">Select VFC</option>
                        {vfcData.map((vfc) => (
                          <option key={vfc._id} value={vfc._id}>
                            {vfc.vfcName}
                          </option>
                        ))}
                      </Form.Control>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <button
                type="button"
                className="btn btn-outline-primary btn-icon-text mt-3"
                onClick={handleViewClick}
              >
                <i className="mdi mdi-file-check btn-icon-prepend"></i>
                Submit
              </button>
            </Form>
          </div>
        </div>
      </div>

      <Container>
        <div className="card">
          <div className="card-body">
            <div className="row icons-list">
              <div className="table-responsive">
                {viewData ? (
                  vfcBasicData ? (
                    <div className="vfc-profile">
                      <table className="vfcProfileTable">
                        <tbody>
                          <tr>
                            <td>1.</td>
                            <td>VFC Name</td>
                            <td>: {vfcBasicData.vfcName}</td>
                          </tr>
                          <tr>
                            <td>2.</td>
                            <td>Registration Date</td>
                            <td>: {vfcBasicData.registrationDate}</td>
                          </tr>
                          <tr>
                            <td>3.</td>
                            <td>Registration Number</td>
                            <td>: {vfcBasicData.registrationNo}</td>
                          </tr>
                          <tr>
                            <td>4.</td>
                            <td>Audit Date</td>
                            <td>: {vfcBasicData.auditDate}</td>
                          </tr>
                          <tr>
                            <td>5.</td>
                            <td>VFC Balance</td>
                            <td>: {vfcBasicData.auditBalance}</td>
                          </tr>
                          <tr>
                            <td>6.</td>
                            <td>VFC Members</td>
                            <td>: {vfcBasicData.totalMembers}</td>
                          </tr>
                          <tr>
                            <td>7.</td>
                            <td>VFC Total Loans Issued</td>
                            <td>: {vfcBasicData.totalLoanAmount}</td>
                          </tr>
                          <tr>
                            <td>8.</td>
                            <td>VFC Loan Outstandings</td>
                            <td>: {vfcBasicData.loanOutstanding}</td>
                          </tr>
                        </tbody>
                      </table>
                      <Button className="vfcButton">Print VFC Profile</Button>
                    </div>
                  ) : (
                    <p>No profile data available for the selected VFC.</p>
                  )
                ) : (
                  <p>Please Select all Required Select Box</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default VFCBasicReports;
